const msg = {
  PAGE_TITLE_LOGIN: 'Вход в личный кабинет',
  PAGE_TITLE_PRIVACY: 'Политика обработки персональных данных',
  PAGE_TITLE_PROFILE: 'Профиль',
  PAGE_TITLE_REGISTER: 'Регистрация на сервисе',
  PAGE_TITLE_REGISTER_CONFIRM: 'Подтверждение регистрации ',
  PAGE_TITLE_STUDENTS: 'Студентам',
  PAGE_TITLE_404: 'Ошибка 404. Страница не найдена',
  PAGE_TITLE_ABOUT: 'О нас',
  PAGE_TITLE_DASHBOARD: 'Личный кабинет',
  PAGE_TITLE_ERROR_REPORT: 'Отчет об ошибке на сайте',
  PAGE_TITLE_EXAM_BEGIN: 'Начать тест',
  PAGE_TITLE_EXAM: 'Тест',
  PAGE_TITLE_EXAM_RESULT: 'Результат',

  COMFIRM_EMAIL:
    'Спасибо за регистрацию! На указанную эл. почту пришло письмо с ссылкой на подтверждение.',
  SUCCESS_COMFIRM_EMAIL:
    'Подверждение успешно! Войдите в систему используя свою эл. почту и пароль.',
  ERROR_COMFIRM_EMAIL: 'Ошибка при подтверждении регистрации. Неверная ссылка.',
  ALLREADY_COMFIRM_EMAIL: 'Возможно аккаунт уже подтвержден.',
  CHECK_YOUR_EMAIL: 'Проверьте свою эл. почту.',
  ERROR_PASSWORD_RESET_CANCEL:
    'Ошибка при попытке отменить восстановление пароля. Возможно в данном действии нет необходимости. В ином случае проверьте ссылку.',
  SUCCESS_PASSWORD_RESET_CANCEL: 'Восстановление пароля отменено.',
  SUCCESS_ERROR_REPORT: 'Сообщение отправлено. Спасибо за помощь!',
  ERROR_ERROR_REPORT: 'Ошибка при отправке. Вот это ирония :)'
};

export default msg;
